<template>
    <div>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-4 align-self-center">
                    <h4 class="page-title"><i class="fas fa-building"></i> Your Organization</h4>
                    <div class="d-flex align-items-center">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link :to="{name: 'dashboard'}">Home</router-link>
                                </li>
                                <li aria-current="page" class="breadcrumb-item active">
                                    <strong>Org</strong>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div class="col-8 align-self-center">
                    <div class="d-flex no-block justify-content-end align-items-center">
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-4 col-xlg-3 col-md-5">
                    <div class="card">
                        <div class="card-body">
                            <div class="m-t-30 text-center">
                                <img :src="tempImage" class="rounded-circle" height="140" v-if="tempImage" width="150"/>
                                <img :src="imageSrc" class="rounded-circle" height="140" v-if="!tempImage && imageSrc" width="150"/>
                                <img class="rounded-circle" height="140" src="../../../assets/images/users/1.jpg" v-if="!tempImage  && !imageSrc" width="150"/>
                                <h4 class="card-title m-t-10">{{currentOrg.name}}</h4>
                                <div class="form-group row m-t-40">
                                    <div class="col-sm-12">
                                        <div class="input-group">
                                            <div class="custom-file">
                                                <input :class="{'is-invalid': submitted && errors.has('attachment-form.attachment')}"
                                                       accept=".JPG,.JPEG,.PNG"
                                                       class="custom-file-input"
                                                       data-vv-as="attachment"
                                                       id="attachment"
                                                       name="attachment"
                                                       ref="file"
                                                       type="file"
                                                       v-on:change="onFileChange($event)"
                                                       v-validate="'required'">
                                                <label class="custom-file-label">{{filename}}</label>
                                            </div>
                                        </div>
                                        <small class="form-text text-muted">{{uploadstatus}}</small>
                                        <div class="invalid-feedback" v-if="submitted && errors.has('attachment-form.attachment')">{{ errors.first('attachment-form.attachment') }}</div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="form-group m-b-0 text-right">
                                        <div class="button-group">
                                            <button @click="uploadFile()" class="btn waves-effect waves-light btn-success" type="button">Save</button>
                                            <button @click="resetAttachment()" class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="list-group">
                            <router-link :to="{name: 'orgprofile'}" class="list-group-item"><i class="fas fa-building"></i> Profile</router-link>
                            <router-link :to="{name: 'orgmembers'}" class="list-group-item"><i class="mdi mdi-account-multiple"></i> Members</router-link>
                            <router-link :to="{name: 'viewsettings'}" class="list-group-item"><i class="mdi mdi-settings"></i> Settings</router-link>
                            <router-link :to="{name: 'taxes'}" class="list-group-item"><i class="mdi mdi-percent"></i> Taxes</router-link>
                            <router-link v-if="currentUser.app_type === 'ACRECX_EXPRESS'" :to="{name: 'parnershiptype'}" class="list-group-item"><i class="fas fa-handshake"></i> Partnership Type</router-link>
                            <router-link v-if="currentUser.app_type === 'ACRECX_MARKETPLACE'" :to="{name: 'orgsubscription'}" class="list-group-item"><i class="mdi mdi-seal"></i> Subscription Plan</router-link>
<!--                            <router-link v-if="currentUser.app_type === 'ACRECX_MARKETPLACE'" :to="{name: 'orginvoice'}" class="list-group-item"><i class="mdi mdi-file-document"></i> Invoice</router-link>-->
<!--                            <router-link v-if="currentUser.app_type === 'ACRECX_MARKETPLACE'" :to="{name: 'plans'}" class="list-group-item"><i class="mdi mdi-wallet-membership"></i> Membership Plan</router-link>-->
                        </div>
                    </div>
                </div>

                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import axios from 'axios';


    export default {
        name: "OrgLayout",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                file: File,
                filename: "Upload Profile Picture",
                uploadstatus: '',
                attachments: [],
                isLoading: false,
                imageSrc: null,
                tempImage: null,
                submitted: false
            };
        },
        mounted() {
            this.getAttachment();
            //https://attachments-acrecx.s3.us-east-2.amazonaws.com/
        },
        methods: {
            async onFileChange(event) {
                this.file     = this.$refs.file.files[0];
                this.filename = this.file.name;

                if(this.file) {
                    let reader    = new FileReader();
                    reader.onload = (event) => {
                        this.tempImage = event.target.result;
                    };
                    reader.readAsDataURL(this.file);
                }
            },
            async uploadFile() {
                this.uploadstatus = "Uploading File Please Wait";
                let signedurl     = await this.getUploadUrl();
                await axios.put(signedurl, this.file);
                this.$toastr('success', 'Profile Picture Uploaded', 'Success');
                this.saveAttachment();
            },
            async getUploadUrl() {
                let signedUrl = await this.$http.get(`/org/${this.currentOrg.id}/attachments/signedurl`, {
                    params: {
                        name: this.filename,
                        type: 'write'
                    }
                });

                let parts        = this.filename.split(".");
                this.attachments = [];
                this.attachments.push({
                    filename: this.filename,
                    filepath: signedUrl.data.key,
                    contenttype: parts[parts.length - 1]
                });

                return signedUrl.data.url;
            },
            async getDownloadUrl(filename) {
                let signedUrl = await this.$http.get(`/org/${this.currentOrg.id}/attachments/signedurl`, {
                    params: {
                        key: filename,
                        type: 'read'
                    }
                });
                return signedUrl.data.url;
            },
            async saveAttachment() {
                await this.$http.post(`/org/${this.currentOrg.id}/attachments`, {attachments: this.attachments});
                this.filename     = "Upload Profile Picture";
                this.uploadstatus = "";
                this.getAttachment();
            },
            async getAttachment() {
                let attachment = await this.$http.get(`/org/${this.currentOrg.id}/attachments`);
                if(attachment.data && attachment.data.length > 0) {
                    // let signedurl   = await this.getDownloadUrl(attachment.data[0].filepath);
                    this.imageSrc = `https://attachments-acrecx.s3.us-east-2.amazonaws.com/${attachment.data[0].filepath}`;
                }
            },
            resetAttachment() {
                this.tempImage    = null;
                this.file         = null;
                this.filename     = "Upload Profile Picture";
                this.uploadstatus = "";
            }
        }
    }
</script>

<style scoped>
    .list-group-item.router-link-active {
        z-index: 2;
        color: #fff;
        background-color: #505160;
        border-color: #505160;
    }
</style>
